import { memo, useEffect, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryResultDetailsPage.module.scss";
import { Layout } from "components/Layout";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BackButton } from "components/BackButton";
import { ISociometryPupilResult } from "../../model/types/sociometryPupilResult";
import { SociometryResultDetailsQuestions } from "../SociometryResultDetailsQuestions/SociometryResultDetailsQuestions";

interface SociometryResultDetailsPageProps {
    className?: string;
}

export const SociometryResultDetailsPage = memo((props: SociometryResultDetailsPageProps) => {
    const { className } = props;
    const [pupilResult, setPupilResult] = useState<ISociometryPupilResult | null>(null);

    const { sessionId } = useParams<{ sessionId: string }>();
    const { pupilId } = useParams<{ pupilId: string }>();

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            try {
                const { data } = await axios.get<ISociometryPupilResult>(
                    `sociometry/pupil/${pupilId}/session/${sessionId}`,
                );
                console.log("data:   ", data);

                if (isMounted) {
                    setPupilResult(data);
                }
            } catch (e) {
                console.error(e);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [sessionId, pupilId]);

    return (
        <Layout>
            <div className={classNames(cls.sociometryResultDetailsPage, {}, [className])}>
                <header className={cls.header}>
                    <BackButton />
                    <p className={cls.title}>Ответы ученика</p>
                </header>
                {pupilResult && (
                    <div className={cls.pupilName}>
                        <p>{pupilResult.pupilFullName || "Ученик"}</p>
                    </div>
                )}
                <div className={cls.content}>
                    {pupilResult ? (
                        pupilResult.answers.map((answer, index) => (
                            <SociometryResultDetailsQuestions key={index} questionNumber={index + 1} answer={answer} />
                        ))
                    ) : (
                        <div className={cls.noData}>Ученик еще не прошел тест</div>
                    )}
                </div>
            </div>
        </Layout>
    );
});

SociometryResultDetailsPage.displayName = "SociometryResultDetailsPage";
